import { NsPanel } from 'components/common/ns-panel/NsPanel';
import { NsLandmark } from 'components/common/ns-landmark/NsLandmark';
import { NsTimeline } from 'components/common/ns-timeline/NsTimeline';
import { NsTimelineEvent } from 'components/common/ns-timeline/NsTimelineEvent';

export const testId = 'heatPumpConfirmationTestId';

export const SolarConfirmation = () => {
  return (
    <>
      <NsLandmark
        type="hillside"
        heading={<>Thanks for signing up for Hive Solar Saver</>}
        decoration="cyan"
      />
      <NsPanel testId={testId}>
        <NsTimeline heading="What happens next" type="standard">
          <NsTimelineEvent
            heading="You've submitted your details"
            status="completed"
          ></NsTimelineEvent>
          <NsTimelineEvent
            heading="We're processing your registration"
            status="inprogress"
          >
            We&apos;ll take the details you&apos;ve given us and run some final
            eligibility checks. This should take up to 7 days.
          </NsTimelineEvent>
          <NsTimelineEvent heading="We'll credit your account" status="pending">
            <>
              Once we&apos;ve registered your account, you&apos;ll start getting
              credits for your Hive Solar Saver. You&apos;ll see the credit on
              your statements as <b>&apos;Hive Solar Saver Credit&apos;.</b>
            </>
          </NsTimelineEvent>
        </NsTimeline>
      </NsPanel>
    </>
  );
};

export default SolarConfirmation;
